module.exports = __webpack_public_path__ + "img/dot-vertical-22.ca8f9bf5.svg";